import React from "react";
import { useParams } from "react-router-dom";
import Service1 from "./Components/Services1";
import Header from "./Components/Header";
import Footer from "./Components/Footer";

import Services2 from "./Components/Services2";
import Services4 from "./Components/Services4";
import Services3 from "./Components/Services3";
import Loader from "./Components/Loader";

const ServicePageSingle=()=>{
    const { title } = useParams();

    return(
        <>
        <Header/>
        <Service1 title={title}/>
       
        <Services2 title={title}/>
        <Services3 title={title}/>
        <Services4 title={title}/>
       <Loader/>
        <Footer/>
        </>
    );
}

export default ServicePageSingle;